import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import IDScan from 'components/IDScan';
import { convertBase64ToImage } from 'utils/image';
import { securityWaitingMessage } from 'utils/securityWaitingMessage';
import {
  newCheckInAction,
  newNextAction,
  newRandomNextAction,
  newLastNextAction,
  getIPAddress,
  NEW_RANDOM_NEXT,
  NEW_LAST_NEXT,
  uploadImageToPreSignedUrlAction,
} from '../../actions/navigation';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import Tooltip from '../../components/Tooltip';
import Validator from '../../components/Validator';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';
import Headline from '../../components/Headline';
import Container from '../../components/Container';
import Transition from '../../components/Transition';
import Modal from '../../components/Modal';
import { useConfig } from '../../config/ConfigContext';
import schema from './securitySchema';
import imgError from '../../assets/images/error.svg';

let idScanSocket = null;
let timeoutTimer = null;
const NORMAL_CLOSE = 'Normal close';
let securityWaitingMessageTimer = null;

const IDASecurity = (props) => {
  const config = useConfig();
  const { checkinData, navigate, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isSecurityModalVisible, setIsSecurityModalVisible] = useState(false);
  const [isDisabledVerifyButton, setIsDisabledVerifyButton] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [idScanUploadFallback, setIdScanUploadFallback] = useState(false);
  const [IDScanData, setIDScanData] = useState(null);
  const [securityWaitingMessageStep, setSecurityWaitingMessageStep] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [frontImagePreSignedUrl, setFrontImagePreSignedUrl] = useState(null);
  const [backOrSecondImagePreSignedUrl, setBackOrSecondImagePreSignedUrl] = useState(null);
  const [selfieImagePreSignedUrl, setSelfieImagePreSignedUrl] = useState(null);
  const [ipAddress, setIpAddress] = useState('');
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');
  const test = searchParams.get('test');

  const getBlackbox = () => {
    if (!window.IGLOO || typeof window.IGLOO.getBlackbox !== 'function') {
      console.log('❌ IGLOO not ready — run a collect first');
      return;
    }
    const result = window.IGLOO.getBlackbox();
    console.log('result.blackbox:', result.blackbox);
    return result.blackbox || '';
  };

  useEffect(() => {
    const { dispatch } = props;

    dispatch(getIPAddress({
      success: (ipResponse) => {
        setIpAddress(ipResponse.ip);
      },
      fail: (err) => {
        console.log('Getting IP address failed', err);
      },
    }));

    if (checkinData) {
      setFirstName(get(checkinData, 'state.data.firstName', get(checkinData, 'data.data.firstName')));
      setFrontImagePreSignedUrl(get(checkinData, 'state.data.frontImagePreSignedUrl', get(checkinData, 'data.data.frontImagePreSignedUrl')));
      setBackOrSecondImagePreSignedUrl(get(checkinData, 'state.data.backOrSecondImagePreSignedUrl', get(checkinData, 'data.data.backOrSecondImagePreSignedUrl')));
      setSelfieImagePreSignedUrl(get(checkinData, 'state.data.selfieImagePreSignedUrl', get(checkinData, 'data.data.selfieImagePreSignedUrl')));
    }

    const sourceData = get(checkinData, 'data', null) || get(checkinData, 'data.data', null) || get(checkinData, 'state.data', null);
    if (!sourceData) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/ida/welcome/?key=${key}`);
    }
    if (document && document.body && !document.getElementById('ioBlackBox')) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.id = 'ioBlackBox';
      hidden.name = 'ioBlackBox';
      document.body.appendChild(hidden);
    }

    window.io_global_object_name = 'IGLOO';
    window.IGLOO = {
      loader: {
        uri_hook: '/iojs/',
        version: 'general5',
        subkey: '',
      },
    };
    const url = '/assets/js/iovation_loader_only.js';

    const script = document.createElement('script');
    script.async = true;
    script.src = url;

    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (securityWaitingMessageStep !== null) {
      securityWaitingMessageTimer = setInterval(() => {
        setSecurityWaitingMessageStep((securityWaitingMessageStep + 1) % 7);
      }, 15000);
    }

    return () => {
      clearInterval(securityWaitingMessageTimer);
    };
  }, [securityWaitingMessageStep]);

  useEffect(() => {
    const { fetch, dispatch } = props;
    const entityType = searchParams.get('entityType');

    if (fetch.isDone[`${NEW_RANDOM_NEXT}`] && !fetch.isRunning[`${NEW_RANDOM_NEXT}`]) {
      const nextActionPath = get(checkinData, 'data.nextAction.path', get(checkinData, 'data.data.nextAction.path'));
      if (nextActionPath) {
        dispatch(newRandomNextAction({
          entityType: entityType || 'application',
          rawUrl: nextActionPath,
          data: {},
        }));
      } else if (get(checkinData, 'data.url')) {
        const routeUrl = checkinData.data.url.replace(config.hostUrl, '');
        navigate(routeUrl);
      } else if (get(checkinData, 'state.url')) {
        const routeUrl = checkinData.state.url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    } else if (fetch.isDone[`${NEW_LAST_NEXT}`] && !fetch.isRunning[`${NEW_LAST_NEXT}`]) {
      if (checkinData.data && get(checkinData, 'data.data.nextAction.path', null)) {
        dispatch(newRandomNextAction({
          entityType: entityType || 'application',
          rawUrl: checkinData.data.data.nextAction.path,
          data: {},
        }));
      } else if (checkinData.data && checkinData.data.url) {
        const routeUrl = checkinData.data.url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    }
  }, [props.checkinData]);

  const handleIDScanSubmit = (data) => {
    setIDScanData(data.IDScanData);
    setIsSecurityModalVisible(true);
  };

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(true);
  };

  const lengthInUtf8Bytes = (str) => {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    const m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
  };

  const handleFail = (err) => {
    idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
    idScanSocket = null;
    timeoutTimer && clearTimeout(timeoutTimer);
    setErrorMessage(err.message || 'An unexpected error occurred, please try again');
    setIsProgressVisible(false);
    // Enable manual upload fallback for front/back on submission failure
    setIdScanUploadFallback(true);
  };

  const endVerificationProcess = () => {
    const { dispatch } = props;
    idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
    idScanSocket = null;
    dispatch(newCheckInAction({
      key,
      workflowType: 'ida',
      data: { identityStatus: true },
      success: (res) => {
        const isProcessing = !get(res, ['data', 'data', 'isReady']);
        if (!isProcessing) {
          dispatch(newLastNextAction({
            key,
            workflowType: 'ida',
            data: { identityVerified: true },
            success: (lastNextRes) => {
              if (get(lastNextRes, ['data', 'data', 'message', 'text']) || lastNextRes.isReady) {
                if (get(lastNextRes, ['data', 'data', 'message', 'text'])) {
                  setErrorMessage(get(lastNextRes, ['data', 'data', 'message', 'text']));
                  setIsProgressVisible(false);
                }
              }
            },
            fail: handleFail,
          }));
        } else {
          handleFail({
            message: 'An unexpected error occurred, please try again',
          });
        }
      },
      fail: (e) => {
        idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
        idScanSocket = null;
        timeoutTimer && clearTimeout(timeoutTimer);
        handleFail(e);
      },
    }));
  };

  const listenVerificationRes = () => {
    const { dispatch } = props;
    const appId = checkinData.attributes.entityId;

    idScanSocket = new WebSocket(`${config.idScanWebsocketUrl}?application_id=${appId}`);
    console.log('connection:', idScanSocket);
    idScanSocket.addEventListener('message', (event) => {
      console.log('eventData:', event.data);
      const eventData = JSON.parse(get(event, 'data'));
      const eventType = get(eventData, 'EventType');
      if (eventType === 'IDSCAN') {
        dispatch(newCheckInAction({
          key,
          workflowType: 'ida',
          data: { identityStatus: true },
          success: async (res) => {
            const isProcessing = !get(res, ['data', 'data', 'isReady']);
            if (!isProcessing) {
              idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
              idScanSocket = null;
              timeoutTimer && clearTimeout(timeoutTimer);
              const iovationBlackBox = await getBlackbox();
              dispatch(newLastNextAction({
                key,
                workflowType: 'ida',
                data: { identityVerified: true, iovationBlackBox: iovationBlackBox || '', IpAddress: ipAddress },
                success: (lastNextRes) => {
                  if (get(lastNextRes, ['data', 'data', 'message', 'text']) || lastNextRes.isReady) {
                    if (get(lastNextRes, ['data', 'data', 'message', 'text'])) {
                      setErrorMessage(get(lastNextRes, ['data', 'data', 'message', 'text']));
                      setIsProgressVisible(false);
                    }
                  }
                },
                fail: handleFail,
              }));
            }
          },
          fail: (e) => {
            idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
            idScanSocket = null;
            timeoutTimer && clearTimeout(timeoutTimer);
            handleFail(e);
          },
        }));
      }
    });

    idScanSocket.addEventListener('close', (event) => {
      if (get(event, 'reason') !== NORMAL_CLOSE || get(event, 'code') !== 1000) {
        console.log('Closed and Reconnecting:', event);
        listenVerificationRes();
      }
    });
  };

  const callNextWorkflow = () => {
    const { dispatch } = props;
    const formData = {
      ...IDScanData,
      countryCode: 'USA',
      verifyFace: true,
    };

    console.log('IDScanData', IDScanData);
    console.log('formData', formData);

    if (test) {
      formData.test = test;
    }

    setIsProgressVisible(true);
    setSecurityWaitingMessageStep(0);

    console.log('IDScan Request: payload size = ', lengthInUtf8Bytes(JSON.stringify(formData)));

    convertBase64ToImage(`data:image/png;base64,${formData.frontImageBase64}`, (blob1) => {
      const frontFile = new File([blob1], 'front-image', { type: 'image/png' });
      dispatch(uploadImageToPreSignedUrlAction({
        data: {
          url: frontImagePreSignedUrl,
          imageData: frontFile,
        },
        success: () => {
          convertBase64ToImage(`data:image/png;base64,${formData.backOrSecondImageBase64}`, (blob2) => {
            const backFile = new File([blob2], 'back-image', { type: 'image/png' });
            dispatch(uploadImageToPreSignedUrlAction({
              data: {
                url: backOrSecondImagePreSignedUrl,
                imageData: backFile,
              },
              success: () => {
                convertBase64ToImage(`data:image/png;base64,${formData.faceImageBase64}`, (blob3) => {
                  const faceFile = new File([blob3], 'face-image', { type: 'image/png' });
                  dispatch(uploadImageToPreSignedUrlAction({
                    data: {
                      url: selfieImagePreSignedUrl,
                      imageData: faceFile,
                    },
                    success: () => {
                      dispatch(newNextAction({
                        key,
                        workflowType: 'ida',
                        data: {
                          frontImagePreSignedUrl,
                          backOrSecondImagePreSignedUrl,
                          selfieImagePreSignedUrl,
                          countryCode: 'USA',
                          verifyFace: true,
                          documentType: formData.documentType,
                          trackString: formData.trackString || null,
                          captureMethod: formData.captureMethod,
                        },
                        success: (res) => {
                          const isProcessing = !get(res, ['data', 'data', 'isReady']);
                          const message = get(res, ['data', 'data', 'message', 'text']);
                          if (!isProcessing || message) {
                            if (!isProcessing) {
                              setIsProgressVisible(false);
                            }
                            if (message) {
                              setIsProgressVisible(false);
                              setErrorMessage(message);
                            }
                          }
                          if (isProcessing) {
                            timeoutTimer = setTimeout(() => {
                              endVerificationProcess();
                            }, config.verificationIntervals);
                            listenVerificationRes();
                          }
                        },
                        fail: handleFail,
                      }));
                    },
                    fail: () => handleFail({ message: 'Unfortunately, we were not able to upload your selfie. Please try again.' }),
                  }));
                });
              },
              fail: () => handleFail({ message: 'Unfortunately, we were not able to upload the back of your driver’s license. Please try again.' }),
            }));
          });
        },
        fail: () => handleFail({ message: 'Unfortunately, we were not able to upload the front of your driver’s license. Please try again.' }),
      }));
    });
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    setErrorMessage('');
  };

  const handleClose = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(false);
  };

  const handleAgreeButtonClick = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(false);
    callNextWorkflow();
  };

  const reset = () => {
    setIsDisabledVerifyButton(true);
    setIDScanData(null);
  };

  const disableVerifyBtn = () => {
    setIsDisabledVerifyButton(true);
  };

  return (
    <Transition className="transition-item wrapper">
      <ContentWrapper>
        <Headline
          header={(
            <>
              <span>A quick ID and selfie check helps protect your account.</span>
              {' '}
              Your info is securely encrypted throughout the process.
              <Tooltip>We adhere to 128-bit SSL protection and strict encryption.</Tooltip>
            </>
          )}
          className="headline-style"
        />
        <Container className="container">
          <IDScan
            handleSubmit={handleIDScanSubmit}
            onReset={reset}
            className={`${
              (
                isSecurityModalVisible
                || !!errorMessage
              ) ? 'hidden-uploader-alert-section ' : ''
            }${
              isProgressVisible ? 'invisible' : 'visible'
            }`}
            onRetakeHook={disableVerifyBtn}
            enableUploadFallback={idScanUploadFallback}
          />
        </Container>
      </ContentWrapper>
      <Footer>
        <FormRow>
          <FormColumn>
            {
              !isProgressVisible
                && (
                <Button
                  className={`btn arrow ${!isDisabledVerifyButton ? 'visibility-hidden' : ''}`}
                  title="Verify Identity"
                  onClick={handleSubmitFrom}
                  isDisabled={isDisabledVerifyButton}
                />
                )
            }
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn>
            <Pagination activeIndex={2} />
          </FormColumn>
        </FormRow>
        {!isDisabledVerifyButton && !isProgressVisible && (
          <div className="id-verify-btn-wrapper">
            <Button
              className="btn arrow id-verify-btn"
              title="Verify Identity"
              onClick={handleSubmitFrom}
            />
          </div>
        )}
        {
          errorMessage
            && (
            <Modal>
              <div className="card-content error-modal security-error">
                <img src={imgError} alt="" />
                <p>{errorMessage}</p>
                <div onClick={handleButtonClick} className="btn btn-red">OK</div>
              </div>
            </Modal>
            )
        }
        {
          isSecurityModalVisible
            && (
            <Modal className="security-modal">
              <div className="card-header">
                <button className="close" aria-label="Close" onClick={handleClose} type="button" />
                <h5>Consent for ID Verification</h5>
              </div>
              <div className="card-content error-modal" style={{ padding: '30px !important' }}>
                <div onClick={handleAgreeButtonClick} className="btn btn-primary">I Agree</div>
                <p>
                  By clicking &quot;I Agree&quot; you give LendingUSA permission via your signature to scan your ID and to share your information with
                  {' '}
                  <a href="http://idscan.net/">IDScan.net</a>
                  , a third-party fraud risk company who uses the information you provided to us to verify your identity and to help prevent ID theft and fraud, and with any State&apos;s Department of Transportation or equivalent agency.
                </p>
              </div>
            </Modal>
            )
        }
      </Footer>
      {
        isProgressVisible && <Spinner message={securityWaitingMessage(securityWaitingMessageStep, firstName)} />
      }
    </Transition>
  );
};

IDASecurity.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(IDASecurity));
